<template>
    <div id="app">
        <vue-progress-bar></vue-progress-bar>

        <div v-if="routePartialType === 'full'">
            <div class="page-wrapper">
                <navbar></navbar>

                <div class="main-content-wrapper">
                    <router-view></router-view>
                </div>

                <footer-main></footer-main>
            </div>
        </div>

        <div v-if="routePartialType === 'account'">
            <div class="page-wrapper">
                <navbar></navbar>

                <div class="main-content-wrapper main-content-wrapper--no-padding">
                    <router-view></router-view>
                </div>

                <footer-main></footer-main>
            </div>
        </div>

        <div v-if="routePartialType === 'meta'">
            <div class="main-content-wrapper">
                <router-view></router-view>
            </div>
        </div>

        <back-to-top></back-to-top>
    </div>
</template>

<script>
import { mapGetters } from 'vuex'

export default {
    name: 'app',
    computed: {
        routePartialType () {
            return this.$route.meta.partialType
        },
        ...mapGetters({
            user: 'user/user',
            starredItems: 'products/starredItems'
        }),
    },
    async mounted() {
    },
    watch: {
        user: async function (newVal, oldVal) {
            if (oldVal === null && newVal !== null) {
                if (!this.starredItems.length && this.user) {
                    await this.$store.dispatch('products/getStarredItems')
                }
            }
        }
    }
}
</script>

<style>
</style>
